import { useEffect, useState } from 'react';

const ENTER_DELAY = 75;
const LEAVE_DELAY = 150;

const useHovered = (targetElOrRef) => {
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const el =
      targetElOrRef && 'current' in targetElOrRef
        ? targetElOrRef.current
        : targetElOrRef;

    if (!el) return;

    let enterT, leaveT;

    const onEnter = () => {
      if (el.hasAttribute?.('disabled')) return; // ignore disabled

      if (leaveT) clearTimeout(leaveT);

      enterT = ENTER_DELAY
        ? setTimeout(() => setHovered(true), ENTER_DELAY)
        : (setHovered(true), null);
    };

    const onLeave = () => {
      if (enterT) clearTimeout(enterT);

      leaveT = LEAVE_DELAY
        ? setTimeout(() => setHovered(false), LEAVE_DELAY)
        : (setHovered(false), null);
    };

    el.addEventListener('mouseenter', onEnter);
    el.addEventListener('mouseleave', onLeave);

    el.addEventListener('focusin', onEnter);
    el.addEventListener('focusout', onLeave);

    return () => {
      if (enterT) clearTimeout(enterT);
      if (leaveT) clearTimeout(leaveT);

      el.removeEventListener('mouseenter', onEnter);
      el.removeEventListener('mouseleave', onLeave);

      el.removeEventListener('focusin', onEnter);
      el.removeEventListener('focusout', onLeave);
    };
  }, [targetElOrRef]);

  return hovered;
};

export default useHovered;
